import { userPermissionsToPortfolio } from '@/store';

const Permissions = Object.freeze({
    // Read and write stuff
    WRITE_ARTICLE: 1 << 0,
    WRITE_NEWS: 2 << 0,
    WRITE_CALENDAR: 4 << 0,
    WRITE_CONTACT: 8 << 0,
    WRITE_ABOUTME: 16 << 0,
    WRITE_EDUCATION: 32 << 0,

    WRITE_OTHER_ARTICLE: 64 << 0,
    WRITE_OTHER_NEWS: 128 << 0,
    WRITE_OTHER_CALENDAR: 256 << 0,
    WRITE_OTHER_CONTACT: 512 << 0,
    WRITE_OTHER_ABOUTME: 1024 << 0,
    WRITE_OTHER_EDUCATION: 2048 << 0,

    READ_ARTICLE: 4096 << 0,
    READ_NEWS: 8192 << 0,
    READ_CALENDAR: 16384 << 0,
    READ_CONTACT: 32768 << 0,
    READ_ABOUTME: 65536 << 0,
    READ_EDUCATION: 131072 << 0,

    // ReadinGroups
    READ_PRIVATE: 262144 << 0,
    READ_MISC: 524288 << 0,
    READ_HOME: 1048576 << 0,
    READ_OCCUPATION: 2097152 << 0,

});

const PermissionGroups = Object.freeze({
    get Guest(){
        return{
            EnglishText: "Guest",
            SwedishText: "Gäst",
            Permissions: Permissions.READ_ABOUTME | Permissions.READ_ARTICLE | Permissions.READ_CALENDAR | Permissions.READ_CONTACT | Permissions.READ_NEWS
        }
    },
    get User(){ 
        return {
            EnglishText: "User",
            SwedishText: "Användare",
            Permissions: this.Guest.Permissions | Permissions.WRITE_NEWS | Permissions.WRITE_CALENDAR | Permissions.WRITE_CONTACT
        }
    },
    get Choosen(){
        return {
            EnglishText: "Choosen",
            SwedishText: "Utvald",
            Permissions: this.User.Permissions | Permissions.WRITE_ARTICLE
        }
    },
    get Admin(){
        return {
            EnglishText: "Administrator",
            SwedishText: "Administratör",
            Permissions: this.Choosen.Permissions | Permissions.WRITE_EDUCATION | Permissions.WRITE_ABOUTME | Permissions.WRITE_OTHER_ARTICLE | Permissions.WRITE_OTHER_NEWS | Permissions.WRITE_OTHER_ABOUTME | Permissions.WRITE_OTHER_CALENDAR  | Permissions.WRITE_OTHER_EDUCATION | Permissions.WRITE_OTHER_CONTACT
        }
    },
    get Owner(){
        return {
            Available: false,
            EnglishText: "Owner",
            SwedishText: "Ägare",
            Permissions: 4294967295 // Max value of int32, this gives every single permission that could ever be within an int32 range 
        }
    } 
});

const ReadingGroups = Object.freeze({
    Home: {
        EnglishText: "Home",
        SwedishText: "Hemma",
        Permissions: Permissions.READ_HOME
    },
    Occupation: {
        EnglishText: "Daly occupation",
        SwedishText: "Daglig sysselsättning/jobb/skola",
        Permissions: Permissions.READ_OCCUPATION
    },
    Misc: {
        EnglishText: "Misc",
        SwedishText: "Annan",
        Permissions: Permissions.READ_MISC,
    },
    Private: {
        EnglishText: "Private",
        SwedishText: "Privat",
        Permissions: Permissions.READ_PRIVATE
    },
});

// Add specific permission or a set of permissions
function addUserPermission(permission){
    let user = getUserPermissions();
    user.permissions |= permission;
    setUserPermissions(user.permissions);
}

// Remove a specific permission or a set of permissions
function deleteUserPermission(permission){
    let user = getUserPermissions();
    user.permissions &= ~permission;
    setUserPermissions(user.permissions);
}

// Get permissions from store
function getUserPermissions(){
    return userPermissionsToPortfolio.getUserPermissions()?.permissions;
}

function setUserPermissions(permissions){
    userPermissionsToPortfolio.setUserPermissions(permissions);
}

export default{
    Permissions,
    PermissionGroups,
    ReadingGroups,
    addUserPermission,
    deleteUserPermission,
    getUserPermissions,
    setUserPermissions
}